import { render, staticRenderFns } from "./confirm_dialog.vue?vue&type=template&id=ed30e6d2&scoped=true"
import script from "./confirm_dialog.vue?vue&type=script&lang=js"
export * from "./confirm_dialog.vue?vue&type=script&lang=js"
import style0 from "./confirm_dialog.vue?vue&type=style&index=0&id=ed30e6d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed30e6d2",
  null
  
)

export default component.exports